import { useContext, useEffect, useState } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import Button from "../Button/Button";
import { LOCALE_LABELS } from "../../shared/constants";
import { useLocation } from "react-router-dom";

function LanguangeMenu() {
    const { translate, lang, setLang } = useContext(TranslationContext);
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    return (
        <>
            <Button
                type="button"
                icon="Wikis"
                label={lang ? LOCALE_LABELS[lang] : ""}
                onClick={() => setIsOpen(true)}
                customCss="text-bd1-smbd color-neutrals-white justify-content-start ps-1 ps-md-12 w-100">
                <i className="icon icon-16 icon-Chevron--right ms-auto"></i>
            </Button>
            <div
                className={`menu_language_picker d-flex d-md-none flex-column gap-22 py-22 px-1 ${isOpen ? "is_active" : ""}`}>
                <Button
                    type="button"
                    customCss="me-auto color-neutrals-black d-md-none text-bd2-rg mt-n1 ms-n1"
                    icon="Chevron--left"
                    onClick={() => setIsOpen(false)}
                    iconSize={24}
                    label={translate("common.back", "Back")}
                />
                <nav className="d-flex flex-column gap-11">
                    <h1 className="text-h2-smbd">
                        {translate("common.change_language", "Change language")}
                    </h1>
                    <ul className="select-options d-flex flex-column gap-11 p-1 bg-neutrals-white">
                        {Object.entries(LOCALE_LABELS).map(([key, label]) => (
                            <li aria-current={lang === key} key={key}>
                                <button
                                    type="button"
                                    className={`d-flex align-items-center gap-1 py-02 px-22 text-bd2-rg color-neutrals-black ${lang === key ? "is_active" : ""}`}
                                    onClick={() => setLang(key)}>
                                    {lang === key && (
                                        <i className="ms-n2 icon icon-16 icon-Checkmark--filled color-green-500"></i>
                                    )}
                                    {label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </>
    );
}

export default LanguangeMenu;
